import React from 'react';
import AppsContainer from '@tenant/core/AppsContainer';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTE_STRING } from 'constants/RouteString';
import AppPackageTable from './components/List/AppPackageTable';

const ListAppPackage = () => {
  return (
    <AppsContainer
      fullView
      title={
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography color='text.primary'>Library</Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.APP_PACKAGE.LIST}>App Packages</Link>
          </Typography>
        </Breadcrumbs>
      }
    >
      <Box
        sx={{
          '& .MuiDataGrid-root': {
            borderLeft: 0,
            borderRight: 0,
            borderTop: 0,
            borderRadius: 0,
          },
        }}
      >
        <AppPackageTable />
      </Box>
    </AppsContainer>
  );
};

export default React.memo(ListAppPackage);
